var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    React.createElement(
      "defs",
      null,
      React.createElement("path", { d: "M21.957 9.576c-.085-.257-.256-.4-.513-.428l-6.112-.899-2.778-5.907c-.086-.228-.271-.342-.556-.342-.285 0-.47.114-.556.342L8.707 8.25l-6.156.899c-.256.028-.427.171-.513.428-.085.228-.028.442.171.642l4.446 4.58-1.069 6.463c0 .285.1.485.3.599.199.171.413.185.64.043l5.472-3.04 5.471 3.04a.688.688 0 0 0 .3.085.62.62 0 0 0 .384-.128c.228-.171.313-.371.256-.6l-1.068-6.462 4.488-4.58c.171-.228.214-.442.128-.642z", id: "navbar-likes" })
    ),
    React.createElement("use", { fill: "#e4edfd", xlinkHref: "#navbar-likes", fillRule: "evenodd" })
  );
});


// WEBPACK FOOTER //
// ./src/shared/components/NavBar/icons/Likes.svg